import { App, Plugin } from 'vue';

import BasicPage from './BasicPage.vue';
import BasicPageContent from './BasicPageContent.vue';
import ApButton from './ApButton.vue';
import ApCheckbox from './ApCheckbox.vue';
import ApRadio from './ApRadio.vue';
import ApToggle from './ApToggle.vue';
import ApEditBlock from './ApEditBlock.vue';
import ApTab from './ApTab.vue';
import ApTable from './ApTable.vue';
import ApLoader from './ApLoader.vue';
import DropButton from './DropButton.vue';
import IconInput from './IconInput.vue';
import ApEditInput from './ApEditInput.vue';
import ApTableCell from './ApTableCell.vue';
import ApNumberBlock from './ApNumberBlock.vue';
import ApDate from './ApDate.vue';
import ApTime from './ApTime.vue';
import ApIcon from './ApIcon.vue';
import CardTemplate from './CardTemplate.vue';

const HelpersPlugin = {
    install(app: App) {
        app.component('BasicPage', BasicPage);
        app.component('BasicPageContent', BasicPageContent);
        app.component('ApButton', ApButton);
        app.component('ApToggle', ApToggle);
        app.component('ApEditBlock', ApEditBlock);
        app.component('ApTab', ApTab);
        app.component('ApTable', ApTable);
        app.component('ApLoader', ApLoader);
        app.component('ApCheckbox', ApCheckbox);
        app.component('ApRadio', ApRadio);
        app.component('DropButton', DropButton);
        app.component('IconInput', IconInput);
        app.component('ApEditInput', ApEditInput);
        app.component('ApTableCell', ApTableCell);
        app.component('ApNumberBlock', ApNumberBlock);
        app.component('ApDate', ApDate);
        app.component('ApTime', ApTime);
        app.component('ApIcon', ApIcon);
        app.component('CardTemplate', CardTemplate);
    },
};

export default HelpersPlugin;
